export const PRIMARY   = "alert alert-primary";
export const SECONDARY = "alert alert-secondary";
export const SUCCESS   = "alert alert-success";
export const DANGER    = "alert alert-danger";
export const WARNING   = "alert alert-warning";
export const INFO      = "alert alert-info";
export const DARK      = "alert alert-dark";
export const LIGHT     = "alert alert-light";